"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _config = require("../../../config/config");

var _excluded = ["id"],
    _excluded2 = ["id"],
    _excluded3 = ["id"];

var CloneFieldButton = function CloneFieldButton(_ref) {
  var selectedQuestion = _ref.selectedQuestion,
      onCloneQuestion = _ref.onCloneQuestion;

  var questionCanBeCopied = function questionCanBeCopied() {
    if (selectedQuestion.data && selectedQuestion.data.pos.length >= 4 && selectedQuestion.answers && selectedQuestion.answers_attributes) return true;
    return false;
  };

  var cloneField = function cloneField() {
    if (!questionCanBeCopied()) return;
    var newYPosition;

    if (selectedQuestion.data.pos[1] < 93) {
      newYPosition = selectedQuestion.data.pos[1] + _config.CLONE_ADDITIONAL_SPACE;
    } else {
      newYPosition = selectedQuestion.data.pos[1] - _config.CLONE_ADDITIONAL_SPACE;
    }

    var newData = {
      pos: [selectedQuestion.data.pos[0], newYPosition, selectedQuestion.data.pos[2], selectedQuestion.data.pos[3]],
      page: selectedQuestion.data.page
    };
    var questionCopy = (0, _extends2["default"])({}, selectedQuestion, {
      answers: selectedQuestion.answers.map(function (answer) {
        var id = answer.id,
            answerWithoutId = (0, _objectWithoutPropertiesLoose2["default"])(answer, _excluded);
        var newAnswer = (0, _extends2["default"])({}, answerWithoutId, {
          data: {
            pos: [answerWithoutId.data.pos[0], answerWithoutId.data.pos[1] + _config.CLONE_ADDITIONAL_SPACE, answerWithoutId.data.pos[2], answerWithoutId.data.pos[3]]
          }
        });
        return newAnswer;
      }),
      answers_attributes: selectedQuestion.answers_attributes.map(function (answer) {
        var id = answer.id,
            answerWithoutId = (0, _objectWithoutPropertiesLoose2["default"])(answer, _excluded2);
        var newAnswer = (0, _extends2["default"])({}, answerWithoutId, {
          data: {
            pos: [answerWithoutId.data.pos[0], answerWithoutId.data.pos[1] + _config.CLONE_ADDITIONAL_SPACE, answerWithoutId.data.pos[2], answerWithoutId.data.pos[3]]
          }
        });
        return newAnswer;
      })
    });
    var id = questionCopy.id,
        questionWithoutId = (0, _objectWithoutPropertiesLoose2["default"])(questionCopy, _excluded3);
    onCloneQuestion(questionWithoutId, newData);
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      variant: null,
      onClick: function onClick() {
        return cloneField();
      },
      "data-cy": "clone-field-button",
      className: "float-right btn-outline-primary",
      style: {
        fontWeight: '500'
      }
    }, "Clone")
  );
};

CloneFieldButton.defaultProps = {
  selectedQuestion: {}
};
CloneFieldButton.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/forbid-prop-types
  selectedQuestion: _propTypes["default"].object,
  onCloneQuestion: _propTypes["default"].func.isRequired
} : {};

var _default = exports["default"] = CloneFieldButton;